import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  display: flex;
  align-items: center;
  color: #e00000;
  background: rgba(224, 0, 0, 0.05);
  border-radius: 5px;
  border: 0;
  border-left: 2px solid;
  padding: 0 16px;
  margin-top: 16px;
  width: 100%;
  height: 54px;
  font-size: 14px;

  svg {
    margin-right: 16px;
  }
`;

export const Description = styled.span``